<template>
    <el-dialog :title="title" :visible="dialogFormVisible" :before-close="handleClose" :closeOnClickModal="false">
        <el-table border default-expand-all :data="dataList" style="width: 100%"   highlight-current-row
            :default-sort="{prop: 'date', order: 'descending'}">
            <el-table-column align="center" type="selection" width="50">
            </el-table-column>
            <el-table-column prop="Url" label="请求路径" sortable width="100">
            </el-table-column>
           <el-table-column prop="Params" label="请求参数" sortable width="200">
            </el-table-column>
            <el-table-column prop="Message" label="错误信息" sortable width="200">
            </el-table-column>
            <el-table-column prop="StackTrace" label="堆栈信息" sortable width="400">
            </el-table-column>
        </el-table>
        <div slot="footer" class="dialog-footer">
            <el-button size="small" @click='handleClose'>取消</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import {
        GetErrorLog
    } from '../../api/log'
    export default {
        data() {
            return {
                title: '错误详情',
                name: 'edit',
                labelwidth: '120px',
                labelPosition: 'right',
                baseURL: window.Global.baseURL,
                dataList: [],
                model: {
                    OID: null
                },
            }
        },
        props: {
            dialogFormVisible: {
                required: true,
                type: Boolean
            },
            errorOID: {
                required: true,
            }
        },
        mounted() {
            this.init();
        },
        methods: {
            init() {
                this.model.OID = this.errorOID;
                this.GetErrorLog();
            },
            handleClose() {
                this.$emit('closeDetailDialog')
            },
            GetErrorLog() {
                let arr = [];
                GetErrorLog(this.model).then(data=>{
                    if(!data.iserror) {
                        arr[0] = data.data;
                        this.dataList = arr;
                    }
                })
            }
        }
    }
</script>

<style>
.el-form-item__content p {
    margin: 0;
}
</style>